import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import Shadow from '../Shadow';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Panel extends React.Component {
  static propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    shadowSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    radius: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'circle']),
    snowCap: PropTypes.bool,
    snowCapColor: PropTypes.oneOf(['primary', 'secondary']),
    noBorder: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    component: 'div',
    title: null,
    size: undefined,
    shadowSize: undefined,
    radius: 'sm',
    snowCap: false,
    snowCapColor: 'primary',
    noBorder: false,
    className: undefined,
    contentClassName: undefined,
    children: null,
  };

  render() {
    const {
      component: Component,
      title,
      noBorder,
      snowCap,
      snowCapColor,
      shadowSize,
      radius,
      size,
      className,
      contentClassName,
      children,
    } = this.props;

    const panelClasses = clx('panel', className, `snow-cap--${snowCapColor}`, {
      [`radius-${radius}`]: radius,
      'snow-cap': snowCap,
    });

    const contentClasses = clx('content', contentClassName, {
      [`padding-${size}`]: size,
      'no-border': noBorder,
    });

    return shadowSize ? (
      <Shadow component={Component} className={panelClasses} size={shadowSize}>
        {title && <div className={styles['title']}>{title}</div>}
        <div className={contentClasses}>{children}</div>
      </Shadow>
    ) : (
      <Component className={panelClasses}>
        {title && <div className={styles['title']}>{title}</div>}
        <div className={contentClasses}>{children}</div>
      </Component>
    );
  }
}
